import React, { Component } from 'react';
import { Col, Row, ListGroup, ListGroupItem, Container, Badge } from 'reactstrap';
import { Link } from 'react-router-dom';
import { SvgAssets } from '../../assets/icons/iconSvg';
import c from '../../constants/Colors';
import { data } from '../../constants/Constants';
import Spinner from "../reusable/Loader";
import { notificacion } from '../../utilitarios/util';
import { GetPdfFilePedidoPedido } from '../../store/sagas/pedidoApi';
export class Tracking extends Component {
  static displayName = Tracking.name;
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      trackingPedido: {},
      trakingDetalle: []
    };
  }

  checkParams() {
    const { state } = this.props.location;

    this.setState({ trackingPedido: state.trackingPedido, trakingDetalle: state.trakingDetalle, loading: false });
  }

  componentDidMount() {
    window.scrollTo(0, 0)
    this.checkParams();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.location.state !== this.props.location.state) {
      this.checkParams();
    }
  }

  postGetPdfPedido = (codigoPedido) => {
    this.setState({ loading: true });
    GetPdfFilePedidoPedido(codigoPedido)
      .then(result => {
        if (result.mo.type == "success") {
          this.setState({
            loading: false,
          });
          window.open(result.dto.urlPdf, "_blank");
        } else {
          throw new Error(result.mo.listMessage.join(", "));
        }
      }).catch((error) => {
        this.setState({ loading: false }, async () => {
          error.message = (error.message == undefined || error.message == null) ? error.description : error.message;
          notificacion("Tracking pedidos", error.message ?? null);
        });
      });
  }

  render() {
    const { loading, trackingPedido, trakingDetalle } = this.state;
    return (
      <div id="mhw">
        <Spinner visible={loading} />
        <div className="breadcrumb">
          <Container>
            <ul>
              <li><Link to='/dashboard'>Dashboard</Link></li>
              <li>Pedidos</li>
              <li><Link to='/historial-pedidos'>Historial de pedidos</Link></li>
              <li>Traking</li>
            </ul>
          </Container>
        </div>
        <Container className="py-5">
          <h6 className="title white mobile"><Link to='/historial-pedidos' className='back'><SvgAssets icon="icon-arrow-left" fill={'#fff'} /></Link>Traking</h6>
          <div className="card">
            <div className="text-left">


              <p className='paragraph-2 mb-1' style={{ color: c.azulClaro, cursor: 'pointer' }}>Número de pedido: <strong>{trackingPedido.vbeln}
              </strong></p>

              <p className='paragraph-2' style={{ color: c.azulClaro }}>Total: <strong>{trackingPedido.sWaers}{(Number(trackingPedido.total)).toLocaleString("en-US", { minimumFractionDigits: 2 })}</strong></p>
              <p className='paragraph-3 mb-0' style={{ color: c.grisMedio }}>Fecha de pedido: {trackingPedido.fechaPedido}</p>
            </div>
            <hr />
            <div className="card_desktop my-5">
              <ul className="tracking">
                {
                  (trakingDetalle.length == 0) ? null :
                    trakingDetalle.map((traking, index) => {
                      let colorPill = this.getColorForTab(traking.codEstad, data.EstadoPedido, traking.color, traking.ultimo);
                      return (
                        <li className="azul" key={index}>
                          <Badge>{traking.estad}</Badge>
                          <span className="fecha">{
                            (traking.tituloFecha == null) ?
                              (traking.codEstad == data.EstadoPedido.PorPagar) ?
                                (
                                  <div><span>{traking.fechaPedido}</span><br />
                                    <span>Fecha máxima de pago<br></br>{traking.fechaVencimiento}</span>
                                    <button
                                      className="btn-small"
                                      onClick={() => this.postGetPdfPedido(trackingPedido.vbeln)}
                                    >
                                      Pedido n° {trackingPedido.vbeln}<SvgAssets icon="icon-download-file" fill={c.rojoClaro} />
                                    </button>
                                  </div>
                                )
                                : traking.fechaPedido
                              : (<span>{traking.tituloFecha}<br></br>{traking.fechaPedido}</span>)}</span>




                          {
                            (traking.urlFactura == "" || traking.urlFactura == null || !traking.flagUrlFactura) ? null :
                              <button
                                className="btn-small"
                                onClick={() => this.loadFactura(traking.urlFactura)}
                              >
                                Factura n° {traking.nomFactura}<SvgAssets icon="icon-download-file" fill={c.rojoClaro} />
                              </button>
                          }
                        </li>
                      )
                    })
                }
              </ul>
            </div>
          </div>
        </Container>
      </div>
    );
  }

  loadFactura = (url) => {
    window.open(url, "_blank");
    // Linking.openURL(url).catch(err => console.log("Couldn't load page", err));
  }

  getColorForTab = (estado, data, colorestado, ultimo) => {
    if (colorestado == true && ultimo == true) {
      switch (estado) {
        case data.PorPagar:
          return c.naranja;
        case data.Entregado:
          return c.verde;
        case data.Expirado:
          return c.rojoClaro;
        case data.EnPreparacion:
          return c.morado;
        case data.Facturado:
          return c.amarillo;
        case data.Pagado:
          return c.azul;
        case data.Despachado:
          return c.celeste;
        case data.Anulado:
          return c.grisMedio;
        default:
          return c.azul;
      }
    }
    else if ((colorestado == true) && (ultimo == false)) {
      return c.azul;
    }
    else {
      return c.grisMedio;
    }
  }
}
